import { apiRequest } from "@/lib/api";

export interface AdminCompany {
  nit: string;
  dv: string | null;
  legalName: string;
  tradeName: string | null;
  teamId: string;
  teamName: string | null;
  onboardingStatus: string;
  dianEnvironment: string;
  certStatus: string | null;
  createdAt: string;
}

export interface AdminCompanyDetail extends AdminCompany {
  regimeCode: string | null;
  addressJson: unknown;
  contactJson: unknown;
  certUploadedAt: string | null;
}

export interface PaginatedAdminCompanies {
  companies: AdminCompany[];
  pagination: { total: number; page: number; pageSize: number; pageCount: number };
}

export interface ListAllCompaniesParams {
  q?: string;
  teamId?: string;
  status?: string;
  page?: number;
  pageSize?: number;
}

export function listAllCompanies(
  params: ListAllCompaniesParams,
): Promise<PaginatedAdminCompanies> {
  return apiRequest("/api/admin/companies", {
    query: params as Record<string, unknown>,
  });
}

export function getCompanyDetail(companyId: string): Promise<AdminCompanyDetail> {
  return apiRequest(`/api/admin/companies/${companyId}`);
}